module.exports = __webpack_public_path__ + "8f877fd043edcf419c051b82f91c4d82.pdf";